import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "task-deadline" }

import { PropType, ref, watch } from "vue";
import { DatepickerTypeEnum, TirPmDatepicker } from "tir-components";


export default /*#__PURE__*/_defineComponent({
  __name: 'task-deadline',
  props: {
  /**Возможность редактировать */
  editing: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  /**Значение */
  modelValue: {
    type: Object as PropType<Date>,
    required: true,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





/**Внутренне значение даты */
const date = ref(props.modelValue);
/**Отслеживаем изменение даты извне */
watch(
  () => props.modelValue,
  () => {
    date.value = new Date(props.modelValue);
  },
  { deep: true },
);

/**Обновить дедлайн */
const updateDeadline = () => {
  if (date.value) {
    if (date.value.getTime() !== props.modelValue.getTime())
      emit("update:modelValue", new Date(date.value));
  } else {
    date.value = new Date(props.modelValue);
  }
};

/**При событии blur */
const onBlur = (isCorrectDate: boolean) => {
  // Обновлеяем дату если она корректная
  if (isCorrectDate) updateDeadline();
};
/**При событии enter */
const onEnter = (isCorrectDate: boolean) => {
  // Обновлеяем дату если она корректная
  if (isCorrectDate) updateDeadline();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TirPmDatepicker), {
      modelValue: date.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
      "is-disabled": !__props.editing,
      input: { label: 'Дедлайн', isSmall: true },
      type: _unref(DatepickerTypeEnum).DateTime,
      onBlur: onBlur,
      onEnter: onEnter,
      onSave: updateDeadline
    }, null, 8, ["modelValue", "is-disabled", "type"])
  ]))
}
}

})